module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "title": "XI"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('b', [_vm._v("Tables")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-001"
    }
  }, [_c('b', [_vm._v("Table 2–1. ")]), _vm._v("Total U.S. supply")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-002"
    }
  }, [_c('b', [_vm._v("Table 2–2. ")]), _vm._v("Lower 48 states with largest annual marketed production in Bcf/d")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-003"
    }
  }, [_c('b', [_vm._v("Table 2–3. ")]), _vm._v("Largest natural gas shale plays")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-004"
    }
  }, [_c('b', [_vm._v("Table 2–4. ")]), _vm._v("Historical US natural gas imports from Canada via pipeline and from LNG via shipping vessels")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-005"
    }
  }, [_c('b', [_vm._v("Table 2–5. ")]), _vm._v("U.S. supply analysis")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-006"
    }
  }, [_c('b', [_vm._v("Table 2–6. ")]), _vm._v("Annual demand for U.S. natural gas in billion cubic feet per day (Bcf/d.)")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-007"
    }
  }, [_c('b', [_vm._v("Table 2–7. ")]), _vm._v("Actual residential and commercial demand in Bcf/d for Jan19-Jun19")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-008"
    }
  }, [_c('b', [_vm._v("Table 2–8. ")]), _vm._v("Actual industrial demand in Bcf/d for Jan19-Jun19:")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-009"
    }
  }, [_c('b', [_vm._v("Table 2–9.")]), _vm._v(" Actual electric generation demand in Bcf/d for Apr19-Sep19:")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-010"
    }
  }, [_c('b', [_vm._v("Table 2–10.")]), _vm._v(" Actual monthly Res/Com demand in Bcf (total) for Nov13-Oct14, and actual monthly Electric Generation demand in Bcf (total) for Nov18-Oct19:")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-011"
    }
  }, [_c('b', [_vm._v("Table 2–11.")]), _vm._v(" Annual natural gas consumption in the industrial sector in Bcf (total) from 2007-2011 with 2009 highlighted")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-012"
    }
  }, [_c('b', [_vm._v("Table 2–12. ")]), _vm._v("U.S. demand analysis")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-013"
    }
  }, [_c('b', [_vm._v("Table 2–13.")]), _vm._v(" Breakdown between the various types of facilities and respective working gas capacities")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-014"
    }
  }, [_c('b', [_vm._v("Table 2–14. ")]), _vm._v("Sample balance sheet (all data in Bcf/d except storage balance, which is total Bcf)")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renvlnk-015"
    }
  }, [_c('b', [_vm._v("Table 2–15. ")]), _vm._v("End of cycle storage balance (Left side in Bcf), with Henry Hub prices (Right side in $/MMBtu) shows cause/effect relationship.")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#renvlnk-023",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 4–1. ")]), _vm._v("Basis swaps visual pricing")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#renvlnk-026",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 4–2. ")]), _vm._v("Outcome of this trade shows various price assumptions for April Permian index and LD1 April.")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#renvlnk-029",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 4–3. ")]), _vm._v("Outcome of this trade shows various price assumptions for April Permian index and LD1 April.")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#renvlnk-040",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 4–4. ")]), _vm._v("The outcomes given various assumptions for Index and LD1")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap42#renvlnk-073",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 4–5. ")]), _vm._v("Daily index price.")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#renvlnk-081",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 5–1. ")]), _vm._v("Storage spreadsheet Example 1.")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#renvlnk-083",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 5–2. ")]), _vm._v("Storage spreadsheet Example 2.")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#renvlnk-093",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 7–1. ")]), _vm._v("Primary energy sources in all generator types (thousand MWh)")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "title": "XII"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#renvlnk-094",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 7–2. ")]), _vm._v("Monthly electricity generation (utility-scale facilities) for 2018 (thousand MWh).")])])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#renvlnk-095",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 7–3. ")]), _vm._v("UPG supply stack showing Marginal Cost, Unit Capacity, and Cumulative Capacity")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#renvlnk-098",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 7–3. ")]), _vm._v("Calendar year 2018 heat rates (Btu/kWh) for different natural gas generator types (EIA)")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#renvlnk-099",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 7–4. ")]), _vm._v("Natural gas burned in generation to replace lost nuclear plant")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#renvlnk-102",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 7–5. ")]), _vm._v("Natural gas consumption vs. electric power net generation")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-103",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8–1. ")]), _vm._v("Conversions")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-105",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8–2. ")]), _vm._v("List of the Projects in Commercial Operation by Baseload Nameplate Liquefaction and Export Capacity in Bcf/d and MTPA year-end 2019.")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-106",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8–3. ")]), _vm._v("Annual LNG exports from the U.S. in billion cubic feet (Bcf).")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-107",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8–4. ")]), _vm._v("Top 10 LNG Exporting Countries According to 2019 Data in Millions of Tonnes (MT). [Source: GIIGNL Annual Report 2020 Edition]")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-108",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8–5. Top 10 LNG Importing Countries According to 2019 Data in Millions of Tonnes (MT). ")]), _vm._v("[Source: GIIGNL Annual Report 2020 Edition].")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-109",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8–6. ")]), _vm._v("Percent of Total Imports from Each Region for the Top 10 Importing Countries in 2019. (Source: GIIGNL Annual Report 2020 Edition)")])]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-110",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8–7. ")]), _vm._v("Prices and Spreads for TTF, NBP, and Henry Hub for July 2020 Futures Contracts as a Proxy for Spot, Short-term Prices.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0